$(document).on('click','.wc_custom_arr',function(){
  if($(this).hasClass('previous_slide')){
    $(this).parents('.slideshow').find('.previous').trigger("click");
  }else{
    $(this).parents('.slideshow').find('.next').trigger("click");
  }
});

$(document).ready(function() {
  
  
  setTimeout(function(){
    // $('.gallery-navigation--scroller').slick({
    //   slidesToShow: 5,
    //   slidesToScroll: 1,
    //   infinite:true,
    //   dots: false,
    //   variableWidth: true,
    //   centerMode: true,
    //   focusOnSelect: true
    // });
    $('.product__inner .product-main-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      fade: false,
      infinite: false,
      asNavFor: '.product__inner .product-navigation-slider',
      slide: '.product-gallery--media',
      prevArrow: '.arrow_left',
      nextArrow: '.arrow_right',
      // adaptiveHeight: true
    });
    $(' .product__inner .product-navigation-slider').slick({
      infinite: false,
      asNavFor: '.product__inner .product-main-slider',
      arrows: false,
      dots: false,
      centerMode: false,
      centerPadding:0,
      variableWidth: true,
      focusOnSelect: true
    });
  }, 500);
  
  
   $('.article-images-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    fade: false,
  });

  $('.down-arrow').click(function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $(window).height() - $('.site-header').height()
    }, 300);
  });

  $('.down-arrow-logo').click(function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $(window).height() - $('.site-header').height()
    }, 300);
  });

  $(window).resize(function() {
    $('.win-height').height($(window).height() - 170);
    if ($(window).width() < 1024) {
      $('.win-heig').height($(window).height() - 100);
    }
  });

  $(window).trigger('resize');

  var h = $('.utility-bar').height();
  $('.desk-img').css({height: 'calc(100vh - 110px'});

  $('a[href^="#"].navmenu-link-parent').each(function(){ 
    var oldUrl = $(this).attr("href");
    var newUrl = oldUrl.replace("#", "javascript:void(0);");
    $(this).attr("href", newUrl);
  });


  $("a.navmenu-link-parent").click(function() {
    $('html, body').animate({
      scrollTop: $(".navmenu-link-parent").offset().top
    }, 1000);
  });
  
  // Product Tabs
  $('.tab_contents').hide();
//   $('.tab').click(function() {
//     var target = $(this.rel);
//     if ($(this).parent().hasClass('tabActive')) {
//       target.slideUp();
//       $(this).parent().removeClass('tabActive');
//     } else {
//       $('.tab_contents').slideUp();
//       $(this).parents('#tabs_container').find('.card-header').removeClass('tabActive');
//       target.slideDown();
//       $(this).parent().addClass('tabActive');
//     }
//   });
  $('.tab').click(function() {
    var target = $(this.rel);
      target.slideToggle();
      $(this).parent().toggleClass('tabActive');
  });
  var garisterEmailField = document.querySelectorAll("input[type='email']");
  garisterEmailField.forEach((e) => {
    console.log(e)
    e.addEventListener("keydown",function(event){
      console.log(event.target.value)
    });
  })
  // if($("#address_province_new").val() === " "){
  //     $('.states.form-field-input').css("border-color","#ff0000");
  //     $('#address_province_container_new .form-field-title').css("color","#ff0000");
  //     return false;
  //   }else{
  //     $('.states.form-field-input').css("border-color","#212121");
  //     $('#address_province_container_new .form-field-title').css("color","#212121");
  //     return true;
  //   }
  
  // $('#create_customer').submit(function(e) {     
  //   e.preventDefault();
  //   if($('input[name="customer[email]"]').val() != $('input[name="customer[confirm_email]"]').val()) {
  //     window.history.back();
  //     alert('Email do not match.');
  //   }else{
  //   if($('input[name="customer[password]"]').val() != $('input[name="customer[confirm_password]"]').val()) {
  //     window.history.back();
  //     alert('Passwords do not match.');
  //   }
  //   }
  // });

});
$(document).on('click', '.addons-product-trigger', function(e){
  e.preventDefault();
  var currentProductId = $(this).closest("form").find('input[name="id"]').val();
  var currentProductQty = $(this).closest("form").find('#product-quantity-input').val();
  console.log(currentProductId,currentProductQty);
  var $th_button = $(this);
  $('.th_ajax_error').html('');
  $('body').addClass('open_bundle_popup');
  var $th_this_parents = $th_button.parents('.th_pb_innercode');
  var $th_variants_length = $th_this_parents.find('.bundle_cls').length;
  var $th_id_array = new Array();
  $th_id_array.push({variant_id: currentProductId, quantity: currentProductQty});
  jQuery('.popular_addons-products .popular_addons-grid').each(function (index, value) {
    var checkbox = $(this).find('.addons-product-id');
    if(checkbox.is(":checked")){
      var $th_temQTY = '1';
      var $th_temVID = checkbox.attr('value');
      $th_id_array.push({variant_id: $th_temVID, quantity: $th_temQTY});
    }
  });
  $th_id_array.reverse();
  function bundle_addtocart(){
    if($th_id_array.length > 0){
      var $th_request = $th_id_array.shift();
      var $th_tempId = $th_request.variant_id;
      var $th_tempQTY = $th_request.quantity;
      var $th_ajax_without_properties = {
        type: 'POST',
        url: '/cart/add.js',
        data: {quantity:$th_tempQTY, id:$th_tempId},
        dataType: 'json',
        beforeSend: function(){
          $th_button.addClass('processing');
          $th_button.attr('disabled',true);
        },
        success: function(cart){
          bundle_addtocart();
        },
        error: function(XMLHttpRequest, textStatus){
          $th_button.children('span.button_text').text('Error');
          console.log(XMLHttpRequest);
        }
      };
      $.ajax($th_ajax_without_properties);
      
    } else{
      $.getJSON('/cart.js', function(cart){
        if(cart.item_count > 0){
          setTimeout(function(){                
            $th_button.children('span.button_text').text('Added to Cart');
            window.location.href = '/cart';
            //ajaxCart.load();
          }, 200);           
        }
      });
    }
  }
  bundle_addtocart();
});



$(document).on('click', '.wc_bundle_product_btn', function(e){
  e.preventDefault();
  var $th_button = $(this);
  var $th_id_array = new Array();  
  var productCount = 0;
  jQuery('ul.wc_bundle_product_list li.bundle_list').each(function (index, value) {

    if($(this).data('inven')){
    }else{
      productCount = productCount + 1;
    }
    var pro_id = $(this).data('vid');
	var pro_aval = $(this).data('inven');
    var $th_temQTY = $(this).data('qty');
    var $th_temVID = pro_id;
    var $th_temAVL = pro_aval;
    $th_id_array.push({variant_id: $th_temVID, quantity: $th_temQTY, available: $th_temAVL});    
  });
  if(productCount == 0){
    $th_id_array.reverse();
    function bundle_addtocart(){
      if($th_id_array.length > 0){
        var $th_request = $th_id_array.shift();
        var $th_tempId = $th_request.variant_id;
        var $th_tempQTY = $th_request.quantity;
        var $th_avail = $th_request.available;
        var $th_ajax_without_properties = {
          type: 'POST',
          url: '/cart/add.js',
          data: {quantity:$th_tempQTY, id:$th_tempId},
          dataType: 'json',
          beforeSend: function(){
           $th_button.addClass('processing');
           $th_button.attr('disabled',true);
          },
          success: function(cart){
            console.log("cart",cart);
            bundle_addtocart();
          },
          error: function(XMLHttpRequest, textStatus){
            $th_button.removeClass('processing');
            $th_button.children('span.button_text').text('Error');
            if($th_avail == 'false'){
              $('.bundle_list').find('.bundle_list_ajax_error').css('display','block');
            }
            console.log(XMLHttpRequest);
          }
        };
        $.ajax($th_ajax_without_properties);

      } else{
        $.getJSON('/cart.js', function(cart){
          if(cart.item_count > 0){
            setTimeout(function(){                
             $th_button.children('span.button_text').text('Added to Cart');
              window.location.href = '/cart';
              //ajaxCart.load();
            }, 200);           
          }
        });
      }
    }
    bundle_addtocart();
  }else{
    jQuery('ul.wc_bundle_product_list li.bundle_list').each(function () {

      if($(this).data('inven')){
      }else{
        $(this).find('.bundle_list_ajax_error').css('display','block');
      }    
    });
    return false;
  }
});
$(document).on('focusin','input[data-quantity-input]',function(e){
  $(this).data('value', $(this).val());
});
$(document).on('input','input[data-quantity-input]',function(e){
  var minimumQty = $(this).data('min');
  var increment = $(this).data('increment');
  var oldvalue = Number($(this).data('value'));
  var newvalue = Number($(this).val());
  var modulo = newvalue % increment;
  if(newvalue >= minimumQty){
    if(modulo > 0 ){
      newvalue = oldvalue;
      alert('This product is only sold on packs of '+increment);
    }
  }else{
    newvalue = oldvalue;
    alert('You need to add minimum '+minimumQty+' qty');
  }
  $(this).val(newvalue);
});


/* $(document).on('change','.select-business-type',function(e){
  var value = $(this).val();
  $('.business-sub-type').slideUp();
  $('.business-sub-type').each(function(){
    $(this).find('.form-field-select').prop('name','');
  });
  if(value == 'Retail/ Residential Design'){
    $('#Retail-sub-options').slideDown();
    $('#Retail-sub-options .form-field-select').prop('name','customer[notes][Business Type]');
  }else if(value == 'Hospitality/ Contract'){
    $('#Hospitality-sub-options').slideDown();
    $('#Hospitality-sub-options .form-field-select').prop('name','customer[notes][Business Type]');
  }else if(value == 'Other'){
    $('#Other-sub-options').slideDown();
    $('#Other-sub-options .form-field-select').prop('name','customer[notes][Business Type]');
  }
}); */


$(document).on('change','input[name="customer[note][Purchased]"]',function(e){
  var value = $(this).val();
  console.log(value);
  $('.purchased-sub-type').slideUp();
 
  if(value == 'I have purchased from Gold Leaf previously'){
    $('#purchased-options').slideDown();
    $('#register_account').prop('required',true);
  }else{
    $('#register_account').prop('required',false);
    $('#purchased-options').slideUp();
  }
});

$(document).on('change','.select-tax-number',function(e){
  var value = $(this).val();
  if(value == "I don't know my EIN or Tax number"){
    $('#tax_number').prop('required',false);
  }else{
    $('#tax_number').prop('required',true);
  }
  $('#tax_number').val('');
  $('#tax_number').removeClass('form-field-filled');
 
});

$(document).on("focus","#tax_number",function(){
  $('.select-tax-number').prop('checked', false);
});


$(document).on('change','.bundle_form-options',function(e){
  var selectedId = $(this).find(':selected').data('variant-id');
  var selectedPrice = Number($(this).find(':selected').data('price'));
  var currentPrice = Number($(this).data('price'));
  var totalPrice = Number($('.total_price.wc_bndle_price').data('total'));
  $(this).parents('.bundle_cls').attr('data-vid',selectedId);
  var newTotalprice = ((totalPrice - currentPrice) + selectedPrice) / 100;
  $('.total_price.wc_bndle_price').text('$'+newTotalprice);
});

$(document).ready(function(){
  setTimeout(function(){
    $('#address_province_new').append('<option value="">Select State</option>') }, 200);
  

  $('.site-header-button.account-logout').click(function(e){
    console.log('bjbjbhjbjbjhhbjh');
    window.location.href ='/account/logout';
  })
});

/*$(document).on('click','.arrow_left',function(){
  $(".gallery-navigation--scroller").slick('slickPrev');
  setTimeout(function(){
    $('.product-gallery--media-thumbnail.slick-slide.slick-current.slick-active').trigger('click');
    // var MediaId = $('.product-gallery--media-thumbnail.slick-slide.slick-current.slick-active').attr('id');
    // console.log('MediaId--',MediaId);
    // var element = document.getElementById(MediaId);
    // var event = new Event('click');
    // element.dispatchEvent(event);
    

  },500);
});*/
/*$(document).on('click','.arrow_right',function(){
  $(".gallery-navigation--scroller").slick('slickNext');
  setTimeout(function(){
    // $('.product-gallery--media-thumbnail.slick-slide.slick-current.slick-active').trigger('click');
    $('.product-gallery--media-thumbnail.slick-slide.slick-current.slick-active').trigger('click');
    // var MediaId = $('.product-gallery--media-thumbnail.slick-slide.slick-current.slick-active').attr('id');
    // console.log('MediaId--',MediaId);
    // var element = document.getElementById(MediaId);
    // console.log('element--',element);
    // var event = new Event('click');
    // element.dispatchEvent(event);
  },500);
});*/